import React, { useEffect, useState } from 'react';
import { SimpleBackdrop } from '../components/SimpleBackdropComponent/SimpleBackdrop';
const BASE_URL = process.env.REACT_APP_API_HOST;
const API_PATH = process.env.REACT_APP_API_PATH;
const COMPLETE_URL = BASE_URL + API_PATH;

const BacQueryPage = ({ token, affiliateDnsName }) => {
  const [loading, setLoading] = useState(true);

  const bacQuery = () => {
    fetch(COMPLETE_URL, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        query: `query getBACNetworkDetails($token: String){
                  getBACNetworkDetails(token:$token){
                    token
                    userId
                    network
                    planUid
                  }
                }`,
        variables: { token: `${token}` },
      }),
    })
      .then(res => res.json())
      .then(result => {
        setLoading(false);
        let networkName = result.data?.getBACNetworkDetails?.network.toLowerCase();
        let network = result.data?.getBACNetworkDetails?.network;

        let token = result.data?.getBACNetworkDetails?.token;
        let subscriberId = result.data?.getBACNetworkDetails?.userId;
        let planUid = result.data?.getBACNetworkDetails?.planUid;
        
        let redirectionLink;
        if (networkName === 'cigna') {
          redirectionLink = `https://cigna-price-transparency.mpoweredhealth.com/find-care?token=${token}&subscriberId=${subscriberId}&planUid=${planUid}&organizationName=${network}`;
        } else if (networkName === 'medcost') {
          redirectionLink = `https://medcost-price-transparency.mpoweredhealth.com/find-care?token=${token}&subscriberId=${subscriberId}&planUid=${planUid}&organizationName=${network}`;
        } else if (networkName === 'mmo') {
          redirectionLink = `https://mmo-price-transparency.mpoweredhealth.com/find-care?token=${token}&subscriberId=${subscriberId}&planUid=${planUid}&organizationName=${network}`;
        } else {
          redirectionLink = window.location.href
            .split('/bactpa-shopping')[0]
            .replace(affiliateDnsName, networkName)
            .concat(`/find-care?token=${token}&subscriberId=${subscriberId}`);
        }

        // let redirectionLink =
        //   `${window.location.href
        //     .split('/bactpa-shopping')[0]
        //     .replace(affiliateDnsName, networkName)}` +
        //   '-qa-member.mpoweredhealth.com';

        //   redirectionLink = redirectionLink.concat(`/find-care?token=${token}&subscriberId=${subscriberId}`);

        window.location.href = redirectionLink;
      })
      .catch(error => {
        setLoading(false);
        console.log(error);
      });
  };

  useEffect(() => {
    bacQuery();
  }, []);

  return (
    <>
      <SimpleBackdrop open={loading} />
    </>
  );
};

export default BacQueryPage;
